import { Maybe, YupArraySchema, yup } from '@framework/validation';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema';
import { LazyWidgetSchema } from '../../../LazyWidgetSchema';
import { Widget, WidgetType } from '../../../Widget';
import { uniqueWidgetCodeSchema } from '../../../validation/uniqueWidgetCodeSchema';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema';
import { ITableColumnWidget, ITableInputWidget } from './ITableInputWidget';
import { ITableRow, TableRowSchema } from './ITableRow';

export const TableInputConfigSchema: yup.ObjectSchema<ITableInputWidget> =
  CommonBaseWidgetSchema.shape({
    label: RichTextAdvancedSchema.label('Etichetta'),
    type: yup.string().exact(WidgetType.TableInput).required(),
    code: uniqueWidgetCodeSchema,
    helpText: RichTextAdvancedSchema.notRequired().label('Descrizione'),
    columns: yup
      .array(LazyWidgetSchema)
      .required()
      .default([]) as YupArraySchema<ITableColumnWidget>,
    rows: yup
      .array(TableRowSchema)
      .required()
      .default([])
      .test(
        'is-unique',
        'Sono presenti dei codici di riga non univoci.',
        checkRowUniqueCode,
      )
      .default([]) as YupArraySchema<ITableRow>,

    /**
     * Table è un widget speciale in cui il campo children non è utilizzato in configurazione
     * ma solo in preview e in fase di compilazione con la materializedTree.
     */
    children: yup.array().notRequired().default([]) as YupArraySchema<Widget>,

    // Layout
    layout: BaseLayoutSchema.shape({
      hideTableHeader: yup
        .boolean()
        .required()
        .default(false)
        .label('Nascondi Header della tabella'),
      rowsLabelColumnWidth: yup
        .number()
        .transform(t => (t === null ? undefined : t))
        .optional()
        .max(100)
        .min(5)
        .label('Larghezza colonna etichetta righe (%)'),
      lightTableHeader: yup
        .boolean()
        .required()
        .default(false)
        .label('Header tabella con sfondo bianco'),
      showTableTitle: yup
        .boolean()
        .required()
        .default(false)
        .label('Mostra titolo della tabella'),
      tableTitle: yup.string().optional().default('').label('Titolo Tabella'),
    }),
  });

/**
 * Controlla che tutti i codici delle righe della tabella siano univoci.
 * In caso contrario, crea un errore sul campo rows.
 */
function checkRowUniqueCode(
  value: Maybe<{ code?: string | null | undefined }[]>,
) {
  if (!value) return true;

  for (const row of value) {
    if (value.filter(r => r.code === row.code).length > 1) {
      return false;
    }
  }

  return true;
}
